import { VueExtension } from '../../utils/extensions/vue';
import Tab from './tab.jsx';
import './tab.scss';

VueExtension.WithInstall(Tab);

export default Tab;
